import classNames from 'classnames/bind';
import Typical from 'react-typical';

import styles from './SlideDemo.module.scss';
import Button from '~/components/Button';
import { FacebookIcon, LinkedInIcon, LocationIcon, RightIcon, ZaloIcon } from '../Icons/Icons';
import images from '~/assets/images';

const cx = classNames.bind(styles);

function SlideDemo() {
    return (
        <div className={cx('wrapper')}>
            <div className={cx('inner', 'grid', 'wide')}>
                <div className={cx('left')}>
                    <div className={cx('demo-hello')}>
                        <h1 className={cx('hello')}>
                            <Typical
                                loop={Infinity}
                                wrapper="b"
                                steps={['Xin chào,', 2000, 'Hello,', 2000, 'Welcome,', 2000, 'Salve,', 2000]}
                            ></Typical>
                        </h1>
                        <h1 className={cx('name')}>Mình tên là Anh</h1>
                    </div>
                    <div className={cx('work')}>
                        <h1>Sinh viên</h1>
                        <h2>
                            <LocationIcon /> Hà Tĩnh
                        </h2>
                    </div>
                    <div className={cx('footer')}>
                        <a href="mailto:anh.bui01vn@gmail.com">
                            <Button
                                className={cx('mailto')}
                                primary
                                rightIcon={<RightIcon className={cx('right-icon')} />}
                            >
                                Gửi Email
                            </Button>
                        </a>
                        <div className={cx('contact')}>
                            <a href="mailto:anh.bui01vn@gmail.com" target="blank" className={cx('gmail-mobile')}>
                                <div className={cx('background')}>
                                    <img src={images.gmail} alt="Email" className={cx('icon')} />
                                </div>
                            </a>
                            <a href="https://facebook.com/anh.buihtbk" target="blank">
                                <div className={cx('background')}>
                                    <FacebookIcon className={cx('icon')} />
                                </div>
                            </a>
                            <a href="https://instagram.com/birdy.mr" target="blank">
                                <div className={cx('background')}>
                                    <img src={images.instagram} alt="instagram" className={cx('icon')} />
                                </div>
                            </a>
                            <a href="https://linkedin.com/in/anh-buihtbk" target="blank">
                                <div className={cx('background')}>
                                    <LinkedInIcon className={cx('icon')} />
                                </div>
                            </a>
                            <a href="https://zaloapp.com/qr/p/si2jhq54q3lx" target="blank">
                                <div className={cx('background', 'background-zalo')}>
                                    <ZaloIcon className={cx('zalo')} />
                                </div>
                            </a>
                            <div className={cx('qr-zalo')}>
                                <img src={images.zaloqr} alt="zaloImage" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SlideDemo;
